export default {"src":"/_next/static/media/button-loading-white.3675e3ba.gif","height":200,"width":200};